import { useOperadoraTelefone } from '@/hooks/useOperadoraTelefone';

export function OperadoraBadge({ telefone }: { telefone?: string | null }) {
  const { data: operadora } = useOperadoraTelefone(telefone);
  if (!operadora) return null;
  const ehClaro = /claro/i.test(operadora);
  return (
    <span
      title={ehClaro ? 'CLARO — alvo quente de portabilidade (telefone Claro)' : `Operadora: ${operadora}`}
      className={`text-[10px] font-semibold px-1.5 py-0.5 rounded-full whitespace-nowrap ${ehClaro ? 'bg-success/15 text-success ring-1 ring-success/40' : 'bg-muted text-muted-foreground'}`}
    >
      {ehClaro ? '📱 CLARO' : operadora}
    </span>
  );
}
